
import styled from 'styled-components';

export const StyledChangesList = styled.div`
  h2 {
    font-size: 18px;
    margin: 0 0 25px 0;
  }
`;

export const StyledChangesItem = styled.div`
  display: grid;
  grid-template-columns: 12px 1fr;
  grid-gap: 10px;
  margin-bottom: 20px;
  
  .info {
    color: #828282;
    font-size: 12px;
  }
  
  .repr {
    line-height: 18px;
  }
  
  .change_reason {
    font-size: 14px;
  }
`;

export const Rectangle = styled.div`
  width: 12px;
  height: 12px;
  border: 2px solid #F2994A;
  box-sizing: border-box;
  border-radius: 2px;
  
  &.action-CREATE {
    border: 2px solid #2D9CDB;
  }
  &.action-UPDATE {}
  &.action-DELETE {
    border: 2px solid #EB5757
  }
  &.action-OTHER {}
`;

export const ChangesLine = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 10px;
  font-size: 12px;
  margin-bottom: 5px;
  
  .label {
    text-align: right;
  }
  
  .value {
    word-break: break-all;
  }
`;